import styled from "styled-components";
export const MultiSelectStyle = styled.div`
  position: relative;
  z-index: ${(props) => (props.zIndex ? "9" : "")};
`;
